export default __webpack_public_path__ + "static/media/greenTickMark.de9b3a65.png";